import { CompanyConfigurationCategories_companyConfigurationCategories_nodes } from '../__generated__/CompanyConfigurationCategories';

export const getDefaultValues = (
  selectedNode: CompanyConfigurationCategories_companyConfigurationCategories_nodes
) => {
  const defaultValue =
    selectedNode.companyBusinessRulesByConfigurationGroupItemId.nodes.map(
      (rule) => ({
        id: rule.id,
        _rowTimestamp: rule._rowTimestamp,
        name: rule.name ?? '',
        sortOrder: rule.sortOrder ?? 0,
        layoutType: rule.layoutType,
        textValue: rule.textValue,
        smallintValue: rule.smallintValue,
        numericValue: rule.numericValue,
        amountValue: rule.amountValue,
        booleanValue: rule.booleanValue,
        columnHint: rule.columnHint,
        configurationCategoryId: rule.configurationCategoryId,
        _isConfigEditingAllowed: rule._isConfigEditingAllowed,
        isCategorySwitchingAllowed: rule.isCategorySwitchingAllowed,
        businessRuleTypeId: rule.businessRuleTypeId,
        warningMessage: rule.warningMessage,
        isRequired: rule.isRequired,
        _isUpdatable: rule._isUpdatable,
        _isDeletable: rule._isDeletable,
      })
    );
  return defaultValue;
};
